export enum MonthlyFee {
    MINIMUM = 'MINIMUM',
    FIXED = 'FIXED',
    PERCENTAGE_NO_MINIMUM = 'PERCENTAGE_NO_MINIMUM',
}

export type StoreBillingRule = {
    storeId: number;
    storeName: string;
    monthlyFeeType: MonthlyFee;
    monthlyFeeValue: number;
    additionalFixedFee: number | null;
    additionalFixedFeeDescription: string | null;
    pagarmeSplitPercentage: number;
    pagbankSplitPercentage: number;
    validUntil: string | null;
    comments: string | null;
    isGlobal: boolean;
    updatedAt: string | null;
    updatedByUserEmail: string | null;
};

export type BillingRulesResponse = {
    stores: StoreBillingRule[];
    summary: {
        inherited: number;
        overrides: number;
        total: number;
    };
};

export type BillingRulesParams = {
    shopManagerId: number;
    onlyOverrides?: boolean;
    orderBy?: string;
    orderDir?: 'asc' | 'desc';
};
